import React, { Component } from 'react';
import Widecard from '../components/Widecard';

class Education extends Component {
  render() {
    return (
      <div className="condiv">
        <h1 className="subtopic">My Education</h1>
        <Widecard title="Bachelor's degree in Finance" where="Ekiti State University" from="2008" to="2016"/>
        <Widecard title="Full Stack Web Development" where="Microverse" from="2019" to="2020"/>
      </div>
    );
  }
}

export default Education;